export default "__VITE_ASSET__DbGeT$wM__"